var paletteDark = {
  // Primary
  primary: '#4a90f4',
  primaryH: '#3570e0',
  primaryLight: '#60a5fa',

  // Secondary
  secondary: '#6b7280',
  secondaryH: '#9ca3af',

  // Text
  defaultText: '#e4e2de',
  secondaryText: '#8b949e',

  // Links
  link: '#f07a4e',
  linkHover: '#f59468',

  // Borders
  border: '#253a50',

  // Status
  success: '#2dd4a0',
  error: '#f87171',
  errorBg: '#301a1a',

  // Card
  cardTitle: '#8b949e',
  cardTitleBorder: '#253a50',

  // Form
  fieldHint: '#6b7280',

  // App header
  appHeaderBg: '#172a40',

  // Base
  white: '#ffffff',
  black: '#000000',

  // Backgrounds
  bgPage: '#0f1b2b',
  bgSurface: '#172a40',
  bgContainer: '#0f1b2b',
  bgSurfaceRaised: '#1e3550',

  // Grey scale
  grey200: '#142332',
  grey300: '#253a50',
  grey400: '#6b7280',
  grey600: '#8b949e',
  grey800: '#cdd0d4',

  // Editor (Monaco)
  editorBg: '#0b1420',
  editorForeground: '#e4e2de',
  editorLineHighlight: '#0f1b2b',
  editorSelection: '#1a3050',
  editorInactiveSelection: '#142332',
  editorLineNumber: '#3d5a80',
  editorLineNumberActive: '#8b949e',
  editorCursor: '#60a5fa',
  editorSelectionHighlight: '#1a304040',
  editorWidgetBg: '#0f1b2b',
  editorWidgetBorder: '#253a50',
  editorSuggestSelectedBg: '#1e3550',
  editorScrollbarShadow: '#00000000',
  editorScrollbarSlider: '#253a5066',
  editorScrollbarSliderHover: '#253a5099',
  editorScrollbarSliderActive: '#253a50cc',

  // Editor syntax highlighting (no # prefix for Monaco rules)
  syntaxComment: '6b7280',
  syntaxKeyword: '7dd3fc',
  syntaxString: 'fbbf24',
  syntaxNumber: 'f0845c',
  syntaxType: '60a5fa',

  // Meta theme-color
  metaThemeColor: '#0f1b2b',

  // Warning / error borders (dark overrides)
  warningBorder: '#78600e',
  errorBorder: '#7f1d1d',

  // Verified badge
  verifiedBg: '#0b3d1e',
  verifiedBorder: '#166534',
  verifiedText: '#4ade80',
};

export default paletteDark;
